
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as canceltjldnwSsnhO0oP1Me_E_i1FfP3hsbEEDKzRQYQSkVe8Meta } from "/app/apps/nuxt/app/pages/sa/events/[shortId]/cancel.vue?macro=true";
import { default as _91_91step_93_93C_sM_kjAVNENplN0hQb9UzQ7XK0SD_aGHP__Lb9H4Y8Meta } from "/app/apps/nuxt/app/pages/commitment/[[step]].vue?macro=true";
import { default as manage_45commitmentVWxC8XbJeLZtQ3mqlCYpuK8JampZgc7PysaulqGz_3IMeta } from "/app/apps/nuxt/app/pages/manage-commitment.vue?macro=true";
import { default as surveyywPITOoKIhzRbFaw0ejROvZSaEETsWHFWpriwXNynDcMeta } from "/app/apps/nuxt/app/pages/survey.vue?macro=true";
import { default as unsubscribeRKax3WVnZFkOuPi4EK3kRhpH_g6qbaNkd0oApDoxPBAMeta } from "/app/apps/nuxt/app/pages/unsubscribe.vue?macro=true";
import { default as survey_45_91slug_931RYhzf2yNuU7eCuwWYHb4pBKy_ovbRmDbQZQqYsdWpAMeta } from "/app/apps/nuxt/app/pages/survey-[slug].vue?macro=true";
export default [
  {
    name: "sa-events-request",
    path: "/sa/events/request",
    alias: ["/events/request"],
    component: () => import("/app/apps/nuxt/app/pages/sa/events/request.vue")
  },
  {
    name: "sa-events-shortId-cancel",
    path: "/sa/events/:shortId()/cancel",
    meta: canceltjldnwSsnhO0oP1Me_E_i1FfP3hsbEEDKzRQYQSkVe8Meta || {},
    alias: ["/events/:shortId/cancel"],
    component: () => import("/app/apps/nuxt/app/pages/sa/events/[shortId]/cancel.vue")
  },
  {
    name: "sa-events-shortId",
    path: "/sa/events/:shortId()",
    alias: ["/events/:shortId"],
    component: () => import("/app/apps/nuxt/app/pages/sa/events/[shortId]/index.vue")
  },
  {
    name: "sa-schools-slug",
    path: "/sa/schools/:slug()",
    alias: ["/schools/:slug"],
    component: () => import("/app/apps/nuxt/app/pages/sa/schools/[slug].vue")
  },
  {
    name: "pages-slug",
    path: "/pages/:slug()",
    component: () => import("/app/apps/nuxt/app/pages/pages/[slug].vue")
  },
  {
    name: "resources-slug",
    path: "/resources/:slug()",
    component: () => import("/app/apps/nuxt/app/pages/resources/[slug].vue")
  },
  {
    name: "commitment-step",
    path: "/commitment/:step(children|confirmation)?",
    meta: { ...(_91_91step_93_93C_sM_kjAVNENplN0hQb9UzQ7XK0SD_aGHP__Lb9H4Y8Meta || {}), ...{"middleware":"commitment-step"} },
    alias: ["/pledge/:step(children|confirmation)?"],
    component: () => import("/app/apps/nuxt/app/pages/commitment/[[step]].vue")
  },
  {
    name: "about",
    path: "/about",
    component: () => import("/app/apps/nuxt/app/pages/about.vue")
  },
  {
    name: "get-involved",
    path: "/get-involved",
    component: () => import("/app/apps/nuxt/app/pages/get-involved.vue")
  },
  {
    name: "icons",
    path: "/icons",
    component: () => import("/app/apps/nuxt/app/pages/icons.vue")
  },
  {
    name: "manage-commitment",
    path: "/manage-commitment",
    meta: manage_45commitmentVWxC8XbJeLZtQ3mqlCYpuK8JampZgc7PysaulqGz_3IMeta || {},
    component: () => import("/app/apps/nuxt/app/pages/manage-commitment.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/app/apps/nuxt/app/pages/privacy.vue")
  },
  {
    name: "resources",
    path: "/resources",
    component: () => import("/app/apps/nuxt/app/pages/resources/index.vue")
  },
  {
    name: "sa",
    path: "/sa",
    component: () => import("/app/apps/nuxt/app/pages/sa/index.vue")
  },
  {
    name: "school-stats",
    path: "/school-stats",
    component: () => import("/app/apps/nuxt/app/pages/school-stats.vue")
  },
  {
    name: "survey",
    path: "/survey",
    meta: surveyywPITOoKIhzRbFaw0ejROvZSaEETsWHFWpriwXNynDcMeta || {},
    component: () => import("/app/apps/nuxt/app/pages/survey.vue")
  },
  {
    name: "terms",
    path: "/terms",
    component: () => import("/app/apps/nuxt/app/pages/terms.vue")
  },
  {
    name: "unsubscribe",
    path: "/unsubscribe",
    meta: unsubscribeRKax3WVnZFkOuPi4EK3kRhpH_g6qbaNkd0oApDoxPBAMeta || {},
    component: () => import("/app/apps/nuxt/app/pages/unsubscribe.vue")
  },
  {
    name: "why-wait",
    path: "/why-wait",
    component: () => import("/app/apps/nuxt/app/pages/why-wait.vue")
  },
  {
    name: "schoolSlug",
    path: "/:schoolSlug()",
    component: () => import("/app/apps/nuxt/app/pages/[schoolSlug].vue")
  },
  {
    name: "survey-slug",
    path: "/survey-:slug()",
    meta: survey_45_91slug_931RYhzf2yNuU7eCuwWYHb4pBKy_ovbRmDbQZQqYsdWpAMeta || {},
    component: () => import("/app/apps/nuxt/app/pages/survey-[slug].vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/apps/nuxt/app/pages/index.vue")
  }
]